package eric.bitria.samples

import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import eric.bitria.samples.scenes.AnimationScene
import eric.bitria.samples.scenes.CameraTourScene
import eric.bitria.samples.scenes.CaptureScene
import eric.bitria.samples.scenes.DuckScene
import eric.bitria.samples.scenes.HDREnvironmentScene
import eric.bitria.samples.scenes.KTXEnvironmentScene
import eric.bitria.samples.scenes.LightingScene
import eric.bitria.samples.scenes.LabelsScene
import eric.bitria.samples.scenes.PickingScene
import eric.bitria.samples.scenes.PrimitivesScene
import eric.bitria.samples.scenes.SolarScene
import eric.bitria.samples.scenes.SplitViewScene
import eric.bitria.samples.scenes.TextureScene
import eric.bitria.samples.scenes.TransparentScene
import eric.bitria.samples.scenes.RuntimeMaterialScene

@Composable
fun App() {
    MaterialTheme {
        var screen: Screen by remember { mutableStateOf(Screen.Home) }
        when (screen) {
            Screen.Home       -> HomeScreen(onNavigate = { screen = it })
            Screen.Duck       -> DuckScene(onBack = { screen = Screen.Home })
            Screen.Primitives -> PrimitivesScene(onBack = { screen = Screen.Home })
            Screen.Lighting   -> LightingScene(onBack = { screen = Screen.Home })
            Screen.Picking    -> PickingScene(onBack = { screen = Screen.Home })
            Screen.Labels     -> LabelsScene(onBack = { screen = Screen.Home })
            Screen.CameraTour -> CameraTourScene(onBack = { screen = Screen.Home })
            Screen.Capture    -> CaptureScene(onBack = { screen = Screen.Home })
            Screen.Solar      -> SolarScene(onBack = { screen = Screen.Home })
            Screen.Animation  -> AnimationScene(onBack = { screen = Screen.Home })
            Screen.SplitView  -> SplitViewScene(onBack = { screen = Screen.Home })
            Screen.Texture    -> TextureScene(onBack = { screen = Screen.Home })
            Screen.KTXEnvironment -> KTXEnvironmentScene(onBack = { screen = Screen.Home })
            Screen.HDREnvironment -> HDREnvironmentScene(onBack = { screen = Screen.Home })
            Screen.Transparent -> TransparentScene(onBack = { screen = Screen.Home })
            Screen.RuntimeMaterial -> RuntimeMaterialScene(onBack = { screen = Screen.Home })
        }
    }
}
